import { _ } from '@ngx-translate/core';
import { MenuItem } from 'primeng/api';

export interface AppMenuItem extends MenuItem {
  dashboard?: {
    descriptionKey: string;
    buttonKey: string;
  };
  permission?: string;
  items?: AppMenuItem[];
}

export const menuItems: AppMenuItem[] = [
  {
    label: 'label.start',
    icon: 'fa-regular fa-house',
    routerLink: '/start',
  },
  {
    label: 'label.checkpoints',
    icon: 'fa-regular fa-location-dot',
    routerLink: '/checkpoints',
    permission: 'view:checkpointTracking',
    dashboard: {
      descriptionKey: 'startPage.checkpoints.description',
      buttonKey: 'startPage.checkpoints.button',
    },
  },
  {
    label: 'label.dashboard',
    icon: 'fa-regular fa-chart-line',
    routerLink: '/dashboard',
    permission: 'view:dashboard',
    dashboard: {
      descriptionKey: 'startPage.dashboard.description',
      buttonKey: 'startPage.dashboard.button',
    },
  },
  {
    label: 'label.eyeCatchers',
    icon: 'fa-regular fa-eye',
    routerLink: '/eye-catchers',
    permission: 'manage:eyecatchers',
    dashboard: {
      descriptionKey: 'startPage.eyeCatchers.description',
      buttonKey: 'startPage.eyeCatchers.button',
    },
  },
  {
    label: 'label.menuInspection',
    icon: 'fa-regular fa-clipboard-check',
    expanded: true,
    items: [
      {
        label: 'label.psas',
        icon: 'fa-regular fa-vest',
        routerLink: '/psas',
        dashboard: {
          descriptionKey: 'startPage.psas.description',
          buttonKey: 'startPage.psas.button',
        },
      },
      {
        label: 'label.routes',
        icon: 'fa-regular fa-route',
        routerLink: '/routes',
        dashboard: {
          descriptionKey: 'startPage.routes.description',
          buttonKey: 'startPage.routes.button',
        },
      },
      {
        label: 'label.inspections',
        icon: 'fa-regular fa-clipboard-check',
        routerLink: '/inspections',
        permission: 'manage:inspections',
        dashboard: {
          descriptionKey: 'startPage.inspections.description',
          buttonKey: 'startPage.inspections.button',
        },
      },
      {
        label: 'label.defects',
        icon: 'fa-regular fa-triangle-exclamation',
        routerLink: '/defects',
        permission: 'manage:defects',
        dashboard: {
          descriptionKey: 'startPage.defects.description',
          buttonKey: 'startPage.defects.button',
        },
      },
    ],
  },
  {
    label: 'label.tasks',
    icon: 'fa-regular fa-list-check',
    routerLink: '/tasks',
    permission: 'manage:tasks',
    dashboard: {
      descriptionKey: 'startPage.tasks.description',
      buttonKey: 'startPage.tasks.button',
    },
  },
  {
    label: 'label.rankings',
    icon: 'fa-regular fa-trophy',
    expanded: true,
    items: [
      {
        label: 'label.userRanking',
        icon: 'fa-regular fa-users',
        routerLink: '/ranking',
        dashboard: {
          descriptionKey: 'startPage.userRanking.description',
          buttonKey: 'startPage.userRanking.button',
        },
      },
      {
        label: 'label.rankingScreen',
        icon: 'fa-regular fa-desktop',
        routerLink: '/ranking/screen',
        dashboard: {
          descriptionKey: 'startPage.rankingScreen.description',
          buttonKey: 'startPage.rankingScreen.button',
        },
      },
    ],
  },
  {
    label: 'label.menuBookings',
    icon: 'fa-regular fa-calendar-check',
    expanded: true,
    items: [
      {
        label: 'label.menuTagesdashboard',
        routerLink: '/buchungen/tagesdashboard',
        icon: 'fa-regular fa-cash-register',
        permission: 'kasse.use',
        dashboard: {
          descriptionKey: _('bookings.tagesdashboard.dashboardDescription'),
          buttonKey: _('bookings.tagesdashboard.dashboardButton'),
        },
      },
      {
        label: 'label.menuSlotOverview',
        routerLink: '/buchungen/slot-overview',
        icon: 'fa-regular fa-calendar-week',
        permission: 'orders.manage',
        dashboard: {
          descriptionKey: _('bookings.slots.dashboardDescription'),
          buttonKey: _('bookings.slots.dashboardButton'),
        },
      },
      {
        label: 'label.menuOrders',
        routerLink: '/buchungen/orders',
        icon: 'fa-regular fa-receipt',
        permission: 'orders.manage',
        dashboard: {
          descriptionKey: _('bookings.orders.dashboardDescription'),
          buttonKey: _('bookings.orders.dashboardButton'),
        },
      },
      {
        label: 'label.menuRequests',
        routerLink: '/buchungen/requests',
        icon: 'fa-regular fa-inbox',
        permission: 'orders.manage',
        dashboard: {
          descriptionKey: _('bookings.requests.dashboardDescription'),
          buttonKey: _('bookings.requests.dashboardButton'),
        },
      },
      {
        label: 'label.menuPaymentIncidents',
        routerLink: '/buchungen/payment-incidents',
        icon: 'fa-regular fa-triangle-exclamation',
        permission: 'orders.manage',
        dashboard: {
          descriptionKey: _('bookings.paymentIncidents.dashboardDescription'),
          buttonKey: _('bookings.paymentIncidents.dashboardButton'),
        },
      },
      {
        label: 'label.menuVouchers',
        routerLink: '/buchungen/vouchers',
        icon: 'fa-regular fa-ticket',
        permission: 'orders.manage',
        dashboard: {
          descriptionKey: _('bookings.vouchers.dashboardDescription'),
          buttonKey: _('bookings.vouchers.dashboardButton'),
        },
      },
      {
        // Throwaway storefront prototype (R1). Publicly reachable without an
        // account; listed here only so staff can find it while it is being
        // tried out. Goes away with the prototype.
        label: 'label.menuShopPrototype',
        routerLink: '/shop',
        icon: 'fa-regular fa-flask',
        permission: 'orders.manage',
      },
    ],
  },
  {
    label: 'label.menuAdmin',
    icon: 'fa-regular fa-gear',
    expanded: true,
    items: [
      {
        label: 'label.editUsers',
        routerLink: '/users',
        icon: 'fa-regular fa-users',
        permission: 'manage:users',
        dashboard: {
          descriptionKey: 'startPage.users.description',
          buttonKey: 'startPage.users.button',
        },
      },
    ],
  },
  {
    label: 'label.menuControlPoints',
    icon: 'fa-regular fa-location-crosshairs',
    expanded: true,
    items: [
      {
        label: 'controlPoints.controlPoints.title',
        routerLink: '/control-points/control-points',
        icon: 'fa-regular fa-location-crosshairs',
        permission: 'controlpoints.manage',
        dashboard: {
          descriptionKey: 'controlPoints.controlPoints.dashboardDescription',
          buttonKey: 'controlPoints.controlPoints.dashboardButton',
        },
      },
      {
        label: 'controlPoints.qualifications.title',
        routerLink: '/control-points/qualifications',
        icon: 'fa-regular fa-award',
        permission: 'controlpoints.manage',
        dashboard: {
          descriptionKey: 'controlPoints.qualifications.dashboardDescription',
          buttonKey: 'controlPoints.qualifications.dashboardButton',
        },
      },
      {
        label: 'controlPoints.overview.title',
        routerLink: '/control-points/status',
        icon: 'fa-regular fa-gauge-high',
        permission: 'controlpoints.view',
        dashboard: {
          descriptionKey: 'controlPoints.overview.dashboardDescription',
          buttonKey: 'controlPoints.overview.dashboardButton',
        },
      },
      {
        label: 'controlPoints.history.title',
        routerLink: '/control-points/history',
        icon: 'fa-regular fa-clock-rotate-left',
        permission: 'controlpoints.view',
        dashboard: {
          descriptionKey: 'controlPoints.history.dashboardDescription',
          buttonKey: 'controlPoints.history.dashboardButton',
        },
      },
    ],
  },
  {
    label: 'label.menuContent',
    icon: 'fa-regular fa-bullhorn',
    expanded: true,
    items: [
      {
        label: 'content.announcements.title',
        routerLink: '/content/announcements',
        icon: 'fa-regular fa-megaphone',
        permission: 'contents.manage',
        dashboard: {
          descriptionKey: 'content.announcements.dashboardDescription',
          buttonKey: 'content.announcements.dashboardButton',
        },
      },
    ],
  },
  {
    label: 'label.menuCatalogAdmin',
    icon: 'fa-regular fa-store',
    expanded: true,
    items: [
      {
        label: 'catalog.products.title',
        routerLink: '/catalog/products',
        icon: 'fa-regular fa-tag',
        permission: 'catalog.manage',
        dashboard: {
          descriptionKey: 'catalog.products.dashboardDescription',
          buttonKey: 'catalog.products.dashboardButton',
        },
      },
      {
        label: 'catalog.categories.title',
        routerLink: '/catalog/categories',
        icon: 'fa-regular fa-folder-tree',
        permission: 'catalog.manage',
        dashboard: {
          descriptionKey: _('catalog.categories.dashboardDescription'),
          buttonKey: _('catalog.categories.dashboardButton'),
        },
      },
      {
        label: 'catalog.additionalProducts.title',
        routerLink: '/catalog/additional-products',
        icon: 'fa-regular fa-cart-plus',
        permission: 'catalog.manage',
        dashboard: {
          descriptionKey: 'catalog.additionalProducts.dashboardDescription',
          buttonKey: 'catalog.additionalProducts.dashboardButton',
        },
      },
      {
        label: 'catalog.openingHourTypes.title',
        routerLink: '/catalog/opening-hour-types',
        icon: 'fa-regular fa-clock',
        permission: 'catalog.manage',
        dashboard: {
          descriptionKey: 'catalog.openingHourTypes.dashboardDescription',
          buttonKey: 'catalog.openingHourTypes.dashboardButton',
        },
      },
      {
        label: 'catalog.contingents.title',
        routerLink: '/catalog/contingents',
        icon: 'fa-regular fa-coins',
        permission: 'catalog.manage',
        dashboard: {
          descriptionKey: 'catalog.contingents.dashboardDescription',
          buttonKey: 'catalog.contingents.dashboardButton',
        },
      },
    ],
  },
];

export const menuLabels = _([
  'label.checkpoints',
  'label.dashboard',
  'label.defects',
  'label.editUsers',
  'label.eyeCatchers',
  'label.inspections',
  'label.menuAdmin',
  'label.menuBookings',
  'label.menuTagesdashboard',
  'label.menuInspection',
  'label.menuCatalogAdmin',
  'label.menuContent',
  'label.menuCatalog',
  'label.menuControlPoints',
  'controlPoints.controlPoints.title',
  'controlPoints.qualifications.title',
  'controlPoints.overview.title',
  'controlPoints.history.title',
  'label.menuOrders',
  'label.menuRequests',
  'label.menuPaymentIncidents',
  'label.menuShopPrototype',
  'label.menuSlotOverview',
  'label.menuVouchers',
  'label.psas',
  'label.routes',
  'label.rankings',
  'label.rankingScreen',
  'label.start',
  'label.tasks',
  'label.userRanking',
  'catalog.products.title',
  'catalog.categories.title',
  'catalog.additionalProducts.title',
  'catalog.openingHourTypes.title',
  'catalog.contingents.title',
  'content.announcements.title',
]);

export const startPageTranslations = _([
  'startPage.checkpoints.button',
  'startPage.checkpoints.description',
  'startPage.dashboard.button',
  'startPage.dashboard.description',
  'startPage.defects.button',
  'startPage.defects.description',
  'startPage.eyeCatchers.button',
  'startPage.eyeCatchers.description',
  'startPage.inspections.button',
  'startPage.inspections.description',
  'startPage.psas.button',
  'startPage.psas.description',
  'startPage.routes.button',
  'startPage.routes.description',
  'startPage.tasks.button',
  'startPage.tasks.description',
  'startPage.rankingScreen.button',
  'startPage.rankingScreen.description',
  'startPage.userRanking.button',
  'startPage.userRanking.description',
  'startPage.users.button',
  'startPage.users.description',
]);
